import { render, staticRenderFns } from "./ContactViewGlobal.vue?vue&type=template&id=2d566e61"
import script from "./ContactViewGlobal.vue?vue&type=script&lang=js"
export * from "./ContactViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports